export var RuleOperators;
(function (RuleOperators) {
    RuleOperators["REGEX"] = "regex";
    RuleOperators["START"] = "start";
    RuleOperators["NOT_START"] = "not-start";
    RuleOperators["END"] = "end";
    RuleOperators["NOT_END"] = "not-end";
    RuleOperators["CONTAIN"] = "contain";
    RuleOperators["NOT_CONTAIN"] = "not-contain";
    RuleOperators["EXACT"] = "exact";
    RuleOperators["NOT_EXACT"] = "not-exact";
})(RuleOperators || (RuleOperators = {}));
export var UrlRuleAction;
(function (UrlRuleAction) {
    UrlRuleAction["REGEX"] = "regex";
    UrlRuleAction["OPERATOR"] = "operator";
    UrlRuleAction["TURN_OFF"] = "turn-off";
})(UrlRuleAction || (UrlRuleAction = {}));
//# sourceMappingURL=project.url.rule.js.map